export default __webpack_public_path__ + "static/media/4_Our_Progress_banner.15fe875d.png";